export default class BaseModel {
  static cleanParam(name = '') {
    if (!name) {
      return '';
    }
    return name.split('?')[0];
  }
}
